import { useState } from "react";
import { ArrowDown, ArrowRight, ArrowUp, LayoutPanelLeft } from "lucide-react";
import Sidebar from "./components/Sidebar";
import ChatInput from "./components/ChatInput";
import QuickActions from "./components/QuickActions";

const useCases = [
  "如何设计对照实验验证药物效果",
  "帮我整理量子纠缠的最新研究进展",
  "生成一篇关于气候变化的学术综述框架",
  "解释CRISPR基因编辑技术的原理",
  "帮我分析这篇论文的研究方法",
];

export default function Home() {
  const [useCasesOpen, setUseCasesOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />

      <main className="flex-1 flex flex-col relative overflow-hidden">
        {sidebarCollapsed && (
          <button
            onClick={() => setSidebarCollapsed(false)}
            className="absolute top-3 left-3 w-7 h-7 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-accent rounded-md transition-colors cursor-pointer z-10"
          >
            <LayoutPanelLeft className="h-4 w-4" />
          </button>
        )}

        <div className="flex-1 flex flex-col items-center justify-center px-6 pb-16">
          <h1 className="text-[28px] font-semibold text-foreground mb-6 tracking-tight">
            开启科研之旅
          </h1>

          <ChatInput />
          <QuickActions />
        </div>

        <div className="absolute bottom-0 left-0 right-0">
          {useCasesOpen && (
            <div className="border-t border-border px-6 py-3">
              <div className="max-w-[1100px] mx-auto grid grid-cols-1 sm:grid-cols-2 gap-2">
                {useCases.map((item, i) => (
                  <button
                    key={i}
                    className="text-left text-xs text-muted-foreground hover:text-foreground hover:bg-accent px-3 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    <ArrowRight className="mr-1 inline h-3.5 w-3.5 text-primary" />
                    {item}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div className="flex justify-center py-2 border-t border-border/50 bg-white">
            <button
              onClick={() => setUseCasesOpen(!useCasesOpen)}
              className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors cursor-pointer px-3 py-1 rounded-full hover:bg-accent whitespace-nowrap"
            >
              <span>探索使用案例</span>
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                {useCasesOpen ? (
                  <ArrowDown className="h-3.5 w-3.5" />
                ) : (
                  <ArrowUp className="h-3.5 w-3.5" />
                )}
              </div>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
